import intl from "react-intl-universal";
import styles from "./index.module.scss";
import classNames from "classnames";
import Logo from "@/components/Logo";
import SVG from "react-inlinesvg";
import { useState, useMemo } from "react";
import { Modal, Table, Pagination, Popover, QRCode } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { dataList } from "@/apis/discover";
import { useColumns } from "./tableColumns/useColumns";
import qqImg from "@/assets/images/community/qq.png";
import subscription from "@/assets/images/community/subscription.png";
const Footer = () => {
  const navigate = useNavigate();
  const [params, setparams] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  let [searchParams] = useSearchParams();
  const type = useMemo(() => {
    return searchParams.get("type") || "";
  }, [searchParams]);

  const [isOpen, setIsOpen] = useState(false);
  const [modelType, setModelType] = useState("");
  const lang = useMemo(() => {
    return localStorage.getItem("lang") || "en-US";
  }, []);
  const [standardData, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const getStandardData = () => {
    dataList({
      filterBySidebarParams: [
        {
          menuBoxName: intl.get("Tag"),
          value: "TAG-5602fe6f-31fc-493c-9163-cec13c47cf3b",
        },
        {
          menuBoxName: intl.get("Tag"),
          value: "TAG-6264b696-da41-441e-836c-7d09cd869cb1",
        },
        {
          menuBoxName: intl.get("Tag"),
          value: "TAG-0983900b-592a-4c7a-8cf8-fdc8566d7c55",
        },
      ],
      pageParam: params,
      secondType: "OpenSpecifications",
    }).then((res) => {
      setDataSource(res.data.records || []);
      setTotal(res.data.total || 0);
    });
  };
  const footerMenu = [
    {
      title: "About",
      children: [
        {
          title: "Who We Are",
          link: "/about/who-we-are",
        },
        {
          title: "Contact Us",
          link: "/about/contact-us",
        },
      ],
    },
    {
      title: "Discover",
      children: [
        {
          title: "Open Data",
          link: "/discover/open-datasets?type=OpenGeospatialData&title=OpenData",
        },
        {
          title: "Open Tools",
          link: "/discover/open-datasets?type=OpenCodes&title=OpenTools",
        },
        {
          title: "Open Docs",
          link: "/discover/open-datasets?type=OpenSpecifications&title=OpenDocs",
        },
        {
          title: "Open Apps",
          link: "/discover/open-datasets?type=OpenWebApps&title=OpenApps",
        },
        {
          title: "Open Skills",
          link: "/skillhub",
        },
      ],
    },
    {
      title: "Infrastructure",
      children: [
        {
          title: "Open Geospatial Engine",
          link: "https://www.openge.org.cn/develop",
          type: "1",
        },

        {
          title: "Open Geospatial Education",
          link: "http://www.openge.org.cn/education",
          type: '1'
        },
        {
          title: "Special Issue",
          link: "/infrastructure/course-hub",
        },
        {
          title: "OpenGA",
          link: "/infrastructure/openGA",
        },
      ],
    },
    {
      title: "Community",
      children: [
        {
          title: "Competitions",
          link: "/community/match-center",
        },
        {
          title: "How to share",
          link: "/community/how-to-share",
        },
        {
          title: "News",
          link: "/community/news",
        },
        {
          title: "Events",
          link: "/community/events",
        },
      ],
    },
  ];
  const { data_EN, data_zh, columns } = useColumns(modelType);

  // type = 1  跳转至外网   type = 2  跳转至项目内页面
  const list = [
    // {
    //   svgpath: '/svg/twitter.svg',
    //   link: "https://x.com/",
    //   type: "1"
    // },
    {
      svgpath: `${process.env.PUBLIC_URL}/svg/github.svg`,
      link: "https://github.com/openrsgis",
      type: "1",
    },
    // , {
    //   svgpath: '/svg/linkedin.svg',
    //   link: "https://www.linkedin.com/",
    //   type: "1"
    // }, {
    //   svgpath: '/svg/instagram.svg',
    //   link: "https://www.instagram.com/",
    //   type: "1"
    // }
    {
      svgpath: `${process.env.PUBLIC_URL}/svg/wechat.svg`,
      link: "https://weixin.qq.com/",
      QRCode: subscription,
      type: "1",
    },
    {
      svgpath: `${process.env.PUBLIC_URL}/svg/qq.svg`,
      link: "https://www.youtube.com/",
      type: "1",
      QRCode: qqImg,
    },
    // , {
    //   svgpath: '/svg/flickr.svg',
    //   link: "https://www.flickr.com/photos/143247548@N03/albums/",
    //   type: "1"
    // }, {
    //   svgpath: '/svg/facebook.svg',
    //   link: "https://www.facebook.com/",
    //   type: "1"
    // }
    // , {
    //   svgpath: '/svg/bluesky.svg',
    //   link: "https://www.baidu.com/",
    //   type: "1"
    // }
    // , {
    //   svgpath: '/svg/slack.svg',
    //   link: "https://www.baidu.com/",
    //   type: "1"
    // }
  ];

  const linkTo = (item) => {
    if (item.type === "1") {
      window.open(item.link);
    } else {
      navigate(item.link);
    }
  };

  const openModal = (e) => {
    setModelType(e);
    if (e === "standards") {
      getStandardData();
    } else {
      setparams({
        currentPage: 1,
        pageSize: 10,
      });
      setTotal(data_zh.length);
    }
    setIsOpen(true);
  };
  const { userInfo } = useSelector((state) => state.user);
  const nicknName = useMemo(() => userInfo?.nickname, [userInfo]);
  const password = useMemo(() => userInfo?.password, [userInfo]);
  const email = useMemo(() => userInfo?.email, [userInfo]);
  const linkOut = (url) => {
    const newPassword = password.replace(/\+/g, "!");
    let src = `${url}?u=${nicknName}&p=${newPassword}&e=${email}`;
    window.open(src, "_blank");
  };
  return (
    <footer className={styles.footerBox}>
      <div className={classNames("container", styles.footer, "flex_box")}>
        <div className={styles.descWrap}>
          <div className={styles.logoWrap}>
            <Logo height={42} size={22} color="#000" />
            <p className={styles.desc}>
              {intl.get("Footer.Desc")}{" "}
            </p>
            <div className={styles.svgBox}>
              {list.map((item, index) => {
                return item.QRCode ? (
                  <Popover
                    key={item.svgpath}
                    content={
                      <img
                        style={{ width: "100px" }}
                        src={item.QRCode}
                        alt="img"
                      />
                    }
                    trigger="hover"
                  >
                    <span>
                      <SVG
                        height={25}
                        width={25}
                        key={index + "_svg"}
                        src={item.svgpath}
                      />
                    </span>

                  </Popover>
                ) : (
                  <span>
                    <SVG
                      height={25}
                      width={25}
                      key={index + "_svg"}
                      onClick={() => linkTo(item)}
                      src={item.svgpath}
                    />
                  </span>
                );
              })}
            </div>
          </div>
          <div className={styles.desBox}>{intl.get("Footer.copyRight")}</div>
        </div>
        <div className={classNames("flex_box flex_around", styles.linkBox)}>
          {footerMenu.map((item, index) => {
            return <div key={item.title}>
              <p>{intl.get('Header.' + item.title)}</p>
              {item.children.map((child) => {
                return (
                  <div key={child.title} onClick={() => linkTo(child)}>
                    {intl.get('Header.' + child.title)}
                  </div>
                );
              })}
            </div>
          })}
          {type === "OpenAITrainingData" && (

            <div>
              <p>{intl.get("Sample Annotation")}</p>
              <div onClick={() => openModal("standards")}>
                {intl.get("Sample Standards")}
              </div>
              <div onClick={() => openModal("tools")}>
                {intl.get("Sample Labeling Tools")}
              </div>
              <div onClick={() => openModal("task")}>
                {intl.get("Sample Tasks")}
              </div>
            </div>)
          }
          {type === "OpenAITrainingData" && <div>
            <p>{intl.get("Sample Repository Platform")}</p>
            <div
              onClick={() => linkOut("https://ogeoa.net/luojiaSet/home")}
            >
              LuoJiaSet
            </div>
          </div>}

        </div>
      </div>
      <Modal
        title={
          modelType === "standards"
            ? intl.get("Sample Standards")
            : modelType === "tools"
              ? intl.get("Sample Labeling Tools")
              : intl.get("Sample Tasks")
        }
        width={modelType === "standards" ? 1200 : 1000}
        open={isOpen}
        maskClosable={false}
        footer={null}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        {modelType === "standards" ? (
          <Table
            rowKey={(_, index) => `row-${index}`} // 使用索引 + 前缀
            pagination={false}
            columns={columns}
            dataSource={standardData}
          />
        ) : (
          <Table
            rowKey={(_, index) => `row-${index}`} // 使用索引 + 前缀
            pagination={false}
            columns={columns}
            dataSource={lang === "zh-CN" ? data_zh : data_EN}
          />
        )}
        {
          <Pagination
            align="end"
            style={{ marginTop: "20px" }}
            current={params.currentPage}
            pageSize={params.pageSize}
            total={total}
            showSizeChanger={false}
            showQuickJumper
            onChange={(page, pageSize) => {
              setparams({
                currentPage: page,
                pageSize: pageSize,
              });
            }}
          />
        }
      </Modal>
    </footer>
  );
};

export default Footer;
